import {
  Directive,
  KeyValueDiffers
} from '@angular/core';
import {
  ElementRef,
  HostListener,
  Input
} from '@angular/core';
@Directive({
  selector: '[appCheckpattern]'
})
export class CheckpatternDirective {
  @Input('appCheckpattern') str: string
  
  @HostListener('blur') onblur() {
    let length = parseInt(this.str.split(',')[0]);
    let limit = parseInt(this.str.split(',')[1]);
    let value = this.el.nativeElement.value;
    if (value.includes('.')) {
      if (value.length - 1 <= length && value.length - (value.indexOf('.') + 1) <= limit) {
        // console.log('valid');
      }
      // else console.log('invalid');
    }
    else{
      if (value.length - 1 <= length){
        // console.log('valid');
      }
      // else console.log('invalid');
    }
  }
  constructor(private el: ElementRef) {


  }

}
